module.exports = __webpack_public_path__ + "img/pc-step-4.a7f65fae.jpg";